import { get, put, Delete, post } from "../axios";

// 设备固件-列表
export const firmwareList = (params) =>
  get(`/web/upgrade/firmware/list`, params);

// 设备列表-列表
export const upgradeDeviceList = (params) =>
  get(`/web/upgrade/device/list`, params);

// 设备固件-新增
export const firmwareAdd = (params) =>
  post(`/web/upgrade/firmware/add`, params);

// 设备固件-删除
export const firmwareDelete = (params) =>
  Delete(`/web/upgrade/firmware/delete/` + params, "");

// 设备固件-详情
export const firmwareView = (params) =>
  get(`/web/upgrade/firmware/view/` + params, "");

// 设备固件-修改
export const firmwareUpdate = (params) =>
  put(`/web/upgrade/firmware/update`, params);

// 网关管理-列表
export const upgradeGatewayList = (params) =>
  get(`/web/upgrade/gateway/list`, params);
